var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-200v-65.846q0-24.769 14.423-46.346 14.423-21.577 38.808-33.501 56.615-27.153 113.307-40.73Q383.231-400 440-400q22.115 0 44.231 2.269 22.115 2.269 44.23 6.808.616 44.923 20.616 84.115 20 39.193 54.923 66.808v40H160Zm587.692 95.385-46.686-46.279v-143.464q-34.237-10.027-55.698-38.45-21.462-28.423-21.462-64.884 0-44.935 31.762-76.698 31.761-31.764 76.692-31.764t76.316 31.794Q840-442.566 840-397.589q0 34.897-19.346 61.435-19.346 26.539-49.885 38.462l38.462 38.461-46.154 46.385 46.154 46.385-61.539 61.846ZM440-489.231q-49.5 0-84.75-35.25T320-609.231q0-49.5 35.25-84.75t84.75-35.25q49.5 0 84.75 35.25t35.25 84.75q0 49.5-35.25 84.75T440-489.231Zm292.308 106.923q12.384 0 21.577-9.577 9.192-9.577 9.192-21.961 0-12.385-9.192-21.577-9.193-9.193-21.577-9.193-12.385 0-21.962 9.193-9.577 9.192-9.577 21.577 0 12.384 9.577 21.961 9.577 9.577 21.962 9.577Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccess);
export default __webpack_public_path__ + "static/media/user-access.cb2cd48b6488fd30d2b582f801d2ceb8.svg";
export { ForwardRef as ReactComponent };